var dom = require('js-utils/dom');

dom.forEach(dom.all('.slider > .slides > .map'), m => {
	dom.on(m, 'click', e => {
		if ('production' !== process.env.NODE_ENV) {
			window.console.log('SlideMap: onClick target:', e.target);
		}

		if ('SPAN' === e.target.tagName) {
			e.stopPropagation();
		}
	});
});
